import Vue from 'vue'
import Router from 'vue-router'

import Cockpit from '@/views/cockpit.vue' // 驾驶舱
import DigitalTwin from '@/views/digitalTwin.vue' // 数字孪生  

Vue.use(Router)

export default new Router({
    mode: 'history', // 去掉url中的#
    routes: [
        {
            path: '/cockpit',
            name: 'cockpit',
            component: Cockpit,
        },
        {
            path: '/digital-Twin',
            name: 'digitalTwin',
            component: DigitalTwin,
        },
    ],
});